// SelectService.tsx
import { Button, IconButton, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import VemigoGrid from 'src/components/VemigoGrid';
import { customerPageStyling } from 'src/theme/vemigoCustomStyles/VemigoCustomStyles';
import { AddServiceBooking } from './addServiceBooking';
import { useCustomerBookingCart } from '../../selectedCustomerData';
import { MessagePopUp } from '../../popUpMessage';
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';
import { useCustomerData } from '../../customerData';

export const SelectService = (props) => {
  const { index } = props;
  const { allTimeSlots, allServices } = useCustomerData();
  const { cartCardsData, setCartCards, cart } = useCustomerBookingCart();
  const columns = [
    { field: 'id', headerName: '#', flex: 1 },
    { field: 'serviceName', headerName: 'Service Name', flex: 1 },
    { field: 'price', headerName: 'Price', flex: 1 },
    { field: 'discountAmount', headerName: 'Discount', flex: 1 },
    { field: 'taxAmount', headerName: 'Tax', flex: 1 },
    { field: 'finalAmount', headerName: 'Amount', flex: 1 },
    { field: 'date', headerName: 'Date', flex: 1 },
    {
      field: 'timeSlotId',
      headerName: 'Time Slot',
      flex: 1,
      renderCell: (params) => {
        const slot = allTimeSlots?.find((x) => x.id === params.value);
        return slot ? `${slot.startTime} - ${slot.endTime}` : '';
      }
    },
    {
      field: 'edit',
      headerName: '',
      width: 18,
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <>
          <IconButton
            onClick={() => {
              setOpenPage(false);
              setActionType('DELETE');
              setRowData(
                cartCardsData[index].services.find((x) => x.id === params.id)
              );
            }}
          >
            <CancelIcon style={{ width: '21px', margin: '0 3px' }} />
          </IconButton>
          <IconButton
            onClick={() => {
              setOpenPage(true);
              setActionType('EDIT');
              setRowData(
                cartCardsData[index].services.find((x) => x.id === params.id)
              );
            }}
          >
            <EditIcon style={{ width: '21px', margin: '0 3px' }} />
          </IconButton>
        </>
      )
    }
  ];

  const [rowData, setRowData] = useState({});
  const [openPage, setOpenPage] = useState(false);
  const [actionType, setActionType] = useState('ADD');
  const [popUpMessage, SetPopUpMessage] = useState(false);

  useEffect(() => {
    const card = cartCardsData[index];
    if (card && card.services.length === 0) {
      const cartServices =
        cart?.cartServices?.filter(
          (service) => service.cartId === cart.cartId
        ) || [];

      const updatedServices = cartServices.map((service) => {
        const slot = allTimeSlots?.find((x) => x.id === service.timeSlotId);

        return {
          id: service.cartServiceId,
          cartServiceId: service.cartServiceId,
          serviceId: service.serviceId,
          serviceName: `${allServices?.find((s) => s.id === service.serviceId)?.name || ''}`,
          price: service.price,
          discountAmount: service.discountAmount,
          discountRate: service.discountRate,
          taxAmount: service.taxAmount,
          taxRate: service.taxRate,
          note: service.note ? service.note : '',
          finalAmount: service.finalAmount,
          date: service.date,
          timeSlotId: service.timeSlotId,
          timeSlot: slot ? `${slot.startTime} - ${slot.endTime}` : ''
        };
      });

      setCartCards((prevCards) =>
        prevCards.map((card, idx) =>
          idx === index ? { ...card, services: updatedServices } : card
        )
      );
    }
  }, [cart, index]);
  return (
    <div style={{ marginBottom: '30px' }}>
      <div style={customerPageStyling.selects.header_btn}>
        <Typography variant="h4">Select Service</Typography>
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            const selected = cartCardsData[index];
            const isCarSelected =
              selected?.car &&
              !Array.isArray(selected.car) &&
              typeof selected.car === 'object';

            const isAddressSelected =
              selected?.address &&
              !Array.isArray(selected.address) &&
              typeof selected.address === 'object';

            if (!isCarSelected || !isAddressSelected) {
              SetPopUpMessage(true);
            } else {
              setOpenPage(true);
            }
          }}
        >
          + Add Service
        </Button>
      </div>
      <VemigoGrid rows={cartCardsData[index].services} columns={columns} />

      <AddServiceBooking
        open={openPage}
        index={index}
        data={rowData}
        actionType={actionType}
        handleClose={() => setOpenPage(false)}
        setActionType={setActionType}
      />

      <MessagePopUp
        openPopUp={popUpMessage}
        conformation={() => SetPopUpMessage(false)}
        message="Select a car and address to select the services"
        hideCancel={true}
      />
    </div>
  );
};
